import React from 'react';



const Gallery = () => {
    return (
        <div className='mt-[100px]'>
            <h1 className='text-[32px] text-primary text-center font-bold mt-10 dark:text-slate-50'>You Complete  <span className='text-secondary'>10 Projects</span> in this course</h1>
            <p className='px-4 lg:text-center text-[15px] text-primary dark:text-slate-200 mt-5'>In addition to teaching programming concepts, skills, we will show 5 additional projects <br className='lg:block hidden'/> so that you can do these 10 projects yourself. If someone understands these 10 projects,<br className='lg:block hidden'/> no one can stop him.</p>
            <section className="overflow-hidden">
                <div className="max-w-screen-xl px-5 py-10 mx-auto ">
                    <div className="flex flex-wrap -m-1 md:-m-2">
                        <div className="flex flex-wrap w-1/2">
                            <div className="w-1/2 p-1 md:p-2">
                                <img alt="gallery" className="block object-cover  object-center w-full  rounded-lg"
                                    src="https://i.ibb.co/mBWCSpx/video-gallery-toolkit-1-1.jpg?fbclid=IwAR0rwStnKbbQfBsGPRytwuaFgUyeW_b2h6bO2qYCdAonTga-l9f4g2ckEok" />
                            </div>
                            <div className="w-1/2 p-1 md:p-2">
                                <img alt="gallery" className="block object-cover object-center w-full  rounded-lg"
                                    src="https://i.ibb.co/YcyZQHv/shopping-cart-2.jpg?fbclid=IwAR3JAVouemB7QjZQywV0AzzWrEjDapHCDfMU4i8YWysrEyOXEDsDoUxwSJs" />
                            </div>
                            <div className="w-full p-1 md:p-2">
                                <img alt="gallery" className="block  object-center w-full h-full rounded-lg"
                                    src="https://i.ibb.co/gZ47D5V/blog-ui-1.jpg?fbclid=IwAR2PtkB0MQRfyRcW629Q1Qe8P2JHj6fF3xuB7Cyl8XFxdfXcKtRW7rZ-PlU" />
                            </div>
                        </div>
                        <div className="flex flex-wrap w-1/2">
                            <div className="w-full p-1 md:p-2">
                                <img alt="gallery" className="block object-cover object-center w-full h-full rounded-lg"
                                    src="https://i.ibb.co/3Ck4NBj/expense-tracker-toolkit.webp?fbclid=IwAR0Ft4wF31q73TcdnTWeBm7Hwyt_v7FNC2pVNVZ-ocjoZn5mBR8FpTzwl8k
                                    " />
                            </div>
                            <div className="w-1/2 p-1 md:p-2">
                                <img alt="gallery" className="block object-cover object-center w-full h-full rounded-lg"
                                    src="https://i.ibb.co/0nDZt0x/project-manager-1.jpg?fbclid=IwAR2WfgD9ut-mcSnrod6oVimKqWbPJoRXNnyvR4B731v1B1RaS7NuyXBYorA" />
                            </div>
                            <div className="w-1/2 p-1 md:p-2">
                                <img alt="gallery" className="block object-center w-full h-full rounded-lg"
                                    src="https://i.ibb.co/0B92zxx/expense-tracker-toolkit-2.jpg?fbclid=IwAR3jh5xI3gj3tFpeYIjPWJb-YkYY8RyMMvc-y5RM191LJk-RbPhuQBIEfEw" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Gallery;